export default {"src":"/_next/static/media/logo.4706d39f.svg","height":124,"width":122,"blurWidth":0,"blurHeight":0};